var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './styles.module.css';
import { MasterCard, Visa } from './Icons';
import { observer } from 'mobx-react-lite';
import { useApplication } from '../../Contexts/ApplicationContext';
export var PaymentCardType;
(function (PaymentCardType) {
    PaymentCardType["VISA"] = "Visa";
    PaymentCardType["MASTERCARD"] = "MasterCard";
})(PaymentCardType || (PaymentCardType = {}));
export var PaymentCardTypeSelect = observer(function () {
    var _a = useApplication().orderFacade, paymentCardType = _a.paymentCardType, setPaymentCardType = _a.setPaymentCardType;
    return (_jsxs("div", __assign({ className: styles.payment_method_wrapper }, { children: [_jsx(PaymentCardTypeView, { type: PaymentCardType.MASTERCARD, onChange: setPaymentCardType, isActive: PaymentCardType.MASTERCARD === paymentCardType }), _jsx("hr", {}), _jsx(PaymentCardTypeView, { type: PaymentCardType.VISA, onChange: setPaymentCardType, isActive: PaymentCardType.VISA === paymentCardType })] })));
});
var PaymentCardTypeView = function (_a) {
    var isActive = _a.isActive, type = _a.type, onChange = _a.onChange;
    return (_jsxs("div", __assign({ onClick: function () { return onChange(type); }, className: styles.payment_method }, { children: [_jsxs("div", __assign({ className: "".concat(styles.radio_button, " ").concat(isActive ? styles.active : '') }, { children: [_jsx("div", { className: "".concat(styles.radio, " ").concat(isActive ? styles.active : '') }), type] })), type === PaymentCardType.MASTERCARD ? _jsx(MasterCard, {}) : _jsx(Visa, {})] })));
};
